import { Component } from '@theme/component';
/** Daily mode follows the visitor's local calendar, including daylight-saving changes. */
class FiveToeOfferCountdown extends Component {
  #interval;
  connectedCallback() {
    super.connectedCallback();
    clearInterval(this.#interval);
    this.#tick();
    this.#interval = setInterval(() => this.#tick(), 1000);
  }
  disconnectedCallback() {
    clearInterval(this.#interval);
    super.disconnectedCallback();
  }
  #tick() {
    const now = new Date();
    const daily = this.dataset.mode === 'daily';
    const deadline = daily ? new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime() : Date.parse(this.dataset.deadline || '');
    const remaining = Math.max(0, Math.ceil((deadline - now.getTime()) / 1000));
    if (!Number.isFinite(deadline) || (!daily && remaining <= 0)) {
      this.hidden = true;
      clearInterval(this.#interval);
      return;
    }
    const values = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
    this.querySelectorAll('[data-time]').forEach((el, i) => { el.textContent = String(values[i]).padStart(2, '0'); });
    this.hidden = false;
  }
}
if (!customElements.get('five-toe-offer-countdown')) customElements.define('five-toe-offer-countdown', FiveToeOfferCountdown);
